// Create axios instances for each base url can add other realated configurations as well.
import axios from 'axios';
import { API } from '../constants/endpoints';

// Function to create an Axios instance with custom configurations
const createAxiosInstance = (baseURL) => {
  return axios.create({
    baseURL,
    // Add other configurations as needed
  });
};

// Function to get the current environment based on the URL
const getEnvironment = () => {
  const { hostname } = window.location;

  if (hostname.includes('local.acquisition')) {
    return 'LOCAL';
  }

  if (hostname.includes('cms.sit10')) {
    return 'CMS_SIT';
  }

  if (hostname.includes('sit10')) {
    return 'SIT';
  }

  if (hostname.includes('sccms10')) {
    return 'SCCMS';
  }

  // Default to production for any other environment
  return 'PROD';
};

// Determine the environment
const environment = getEnvironment();

// Initialize the appropriate Axios instance based on the environment
const axiosInstance = createAxiosInstance(API[environment]);

export default axiosInstance;
